import { Truemed } from 'ui/icons/icons/Growth/Truemed';
import { HsaFsaCheck } from 'ui/icons/icons/Growth/HsaFsaCheck';
import { useTranslation } from '@whoop/i18n/lang/client';

export function TruemedHsaFsaBadge() {
  const { t } = useTranslation('hsaFsa');
  return (
    <div className='flex items-center justify-center gap-x-1 whitespace-nowrap'>
      <div className='flex items-center text-sm font-bold text-black'>
        <HsaFsaCheck /> HSA/FSA
      </div>
      <span className='font-regular text-sm text-black'>
        {t('eligibleWith')}
      </span>
      <Truemed />
    </div>
  );
}
